var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCreditCardCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 29.9987L30.0002 33.332L36.6668 26.6654M36.6668 16.6654H3.3335M36.6668 19.9987V13.6654C36.6668 11.7985 36.6668 10.8651 36.3035 10.1521C35.9839 9.52486 35.474 9.01492 34.8468 8.69535C34.1338 8.33203 33.2003 8.33203 31.3335 8.33203H8.66683C6.79999 8.33203 5.86657 8.33203 5.15353 8.69534C4.52632 9.01492 4.01639 9.52486 3.69681 10.1521C3.3335 10.8651 3.3335 11.7985 3.3335 13.6654V26.332C3.3335 28.1989 3.3335 29.1323 3.69681 29.8453C4.01639 30.4725 4.52632 30.9825 5.15353 31.302C5.86657 31.6654 6.79999 31.6654 8.66683 31.6654H20.0002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCardCheck);
export default __webpack_public_path__ + "static/media/iconCreditCardCheck.65bdb3f76a3dd5c765aa1d76b81f34aa.svg";
export { ForwardRef as ReactComponent };